import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/farms/token-farm/claim-img.png'


const _withScopeId = n => (_pushScopeId("data-v-c79945ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "farming-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title-wrapper" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "token-row" }
const _hoisted_7 = { class: "token" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, null, -1))
const _hoisted_9 = { class: "token" }
const _hoisted_10 = { class: "amount-row" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "APY", -1))
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "name" }, "Earn", -1))
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "stake-row" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "name" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "name" }
const _hoisted_24 = { class: "info-row" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "name" }
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "name" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "claim-row" }
const _hoisted_32 = { class: "left" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_34 = { class: "amount-wrapper" }
const _hoisted_35 = { class: "amount" }
const _hoisted_36 = { class: "name" }
const _hoisted_37 = { class: "btn-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_StakeDialog = _resolveComponent("StakeDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: _normalizeClass(["coin-img token2", _ctx.farm.token2Symbol]),
      src: _ctx.farm.tokenIcon
    }, null, 10, _hoisted_2),
    _createElementVNode("img", {
      class: _normalizeClass(["coin-img token1", _ctx.farm.token1Symbol]),
      src: _ctx.farm.originTokenIcon
    }, null, 10, _hoisted_3),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.farm.title), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.farm.token1Symbol), 1),
      _hoisted_8,
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.farm.token2Symbol), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.data.apy) + "%", 1)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("span", _hoisted_16, _toDisplayString(this.$props.farm.earnTokenSymbol), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.data.totalStaked), 1),
        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('totalStaked')), 1)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.data.myStaked), 1),
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('myStaked')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('dayDistribution')), 1),
        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.data.dailyDistribution), 1)
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('halvingTime')), 1),
        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.data.halvingTime), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.data.claimable), 1),
          _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('claimable')), 1)
        ])
      ]),
      _createVNode(_component_el_button, {
        onClick: _ctx.claimAll,
        class: "claim-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('claim')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_37, [
      (_ctx.data.approvedAmount < 1000)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "approve-btn",
            onClick: _ctx.approve
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('approve')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_el_button, {
              class: "stake-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.stakeDialogVisible = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('stake')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "claim-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.withdrawDialogVisible = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('unstake')), 1)
              ]),
              _: 1
            })
          ], 64))
    ]),
    _createVNode(_component_StakeDialog, {
      visible: _ctx.stakeDialogVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stakeDialogVisible) = $event)),
      data: _ctx.data,
      onSubmit: _ctx.stake
    }, null, 8, ["visible", "data", "onSubmit"]),
    _createVNode(_component_StakeDialog, {
      visible: _ctx.withdrawDialogVisible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.withdrawDialogVisible) = $event)),
      data: _ctx.data,
      onSubmit: _ctx.withdrawToken,
      type: "unstake"
    }, null, 8, ["visible", "data", "onSubmit"])
  ]))
}